<template>
    <div class="video-view">
        <video controls preload="auto" :poster="cover" :width="videoWidth" :height="videoHeight" style="width:100%;height:100%;object-fit;contain"
            :src="videoUrl"></video>
    </div>
</template>

<script>
export default {
    name: 'videoView',
    props: {
        videoUrl: {
            type: String,
            default: ''
        },
        cover: {
            type: String,
            default: ''
        },
        videoWidth: {
            type:Number,
            default:'100%',
            require:false
        },
        videoHeight: {
            type: Number,
            default:'100%',
            require:false
        }
    }
}
</script>

<style></style>